import * as React from "react"
import { SVGProps } from "react"
const NoEnergy = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 143 154" {...props}>
    <path
      fill="#FFF200"
      d="M50 20h12v30h18V20h12v30h16v52l-14 16H82v26H60v-26H48l-14-16V50h16Z"
    />
    <path
      fill="#FFF200"
      d="m20.235 27.149 104.652 104.652-4.243 4.242L15.992 31.392z"
    />
    <path d="M24.477 22.906 129.13 127.558l-4.242 4.243L20.235 27.149z" />
  </svg>
)
export default NoEnergy
